export default {
  hadith: (state) => {
    return state.hadith;
  },

  allNews: (state) => {
    return state.allNews;
  },

  lastNews: (state) => {
    return state.lastNews;
  },

  chooseNews: (state) => {
    return state.chooseNews;
  },

  electronicServices: (state) => {
    return state.electronicServices;
  },

  newsLetters: (state) => {
    return state.newsLetters;
  },

  moreLikeNews: (state) => {
    return state.moreLikeNews;
  },

  groups: (state) => {
    return state.groups;
  },

  newsGroups: (state) => {
    return state.newsGroups;
  },
  newsGroupOpetions: (state) => {
    const newsGroupOpetions = [];
    state.newsGroups.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      newsGroupOpetions.push(pushItem);
    }
    return newsGroupOpetions;
  },

  moreViewNews: (state) => {
    return state.moreViewNews;
  },

  newestNews: (state) => {
    return state.newestNews;
  },

  oneNews: (state) => {
    return state.oneNews;
  },

  contactUs: (state) => {
    return state.contactUs;
  },

  introductions: (state) => {
    return state.introductions;
  },
  oneIntroduction: (state) => {
    return state.oneIntroduction;
  },

  lastProvinceNews: (state) => {
    return state.lastProvinceNews;
  },

  links: (state) => {
    return state.links;
  },

  slider: (state) => {
    return state.slider;
  },

  banner: (state) => {
    return state.banner;
  },

  zones: (state) => {
    return state.zones;
  },

  lastSubjects: (state) => {
    return state.lastSubjects;
  },
  chooseSubjects: (state) => {
    return state.chooseSubjects;
  },
  moreLikeSubjects: (state) => {
    return state.moreLikeSubjects;
  },
  moreviewSubjects: (state) => {
    return state.moreviewSubjects;
  },
  newestSubjects: (state) => {
    return state.newestSubjects;
  },
  allSubjects: (state) => {
    return state.allSubjects;
  },
  getOneSubjects: (state) => {
    return state.getOneSubjects;
  },
};
